import { gql } from "@apollo/client";

export const CREATE_ERRORS = gql`
  mutation CreateErrors($input: createErrorsInput) {
    createErrors(input: $input) {
      Id
    }
  }
`;
export const GET_ERRORREPORTS = gql`
  query ErrorReports($fromDate: String, $toDate: String, $orgId: Int) {
    errorReports(fromDate: $fromDate, toDate: $toDate, orgId: $orgId) {
      Id
      userId
      createdAt
      errorMessage
      endpoint
      orgId
      organisationDetails {
        name
      }
      screenName
    }
  }
`;
